export default "__VITE_ASSET__BYUvgqzm__"